module.exports = __webpack_public_path__ + "static/img/pin-larvicide-scheduled.41576b9.svg";